export default {
  bell: {
    title: 'Notifications',
    open: 'Open notifications',
    unread: 'No unread notification | One unread notification | {count} unread notifications',
    markAllRead: 'Mark all as read',
    manage: 'Manage my notifications',
    unreadMarker: 'Unread',
    loadFailed: 'Notifications could not be loaded.',
    markFailed: 'The notification could not be marked as read.',
    empty: {
      title: 'No notifications',
      description:
        'What shows here is chosen in your notification settings: turn on “In the app” for new files in a workspace, for registration requests or for your channels’ sales.',
    },
  },
  lines: {
    uploadReceived: '“{title}” was added to {workspace}',
    uploadReceivedBy: '{uploader} added “{title}” to {workspace}',
    uploadPendingModeration: '“{title}” awaits approval in {workspace}',
    uploadPendingModerationBy: '{uploader} added “{title}” to {workspace}: it awaits approval',
    membershipRequestReceived: '{name} ({email}) asks to join the organization',
    membershipRequestsWaiting:
      'No registration request is waiting | A registration request has been waiting for an answer for {days} days | {count} registration requests are waiting for an answer, the oldest for {days} days',
    saleReceived: '{channel}: new sale — {what}',
    saleReceivedAmount: '{channel}: new sale — {what}, {amount} excl. tax',
    subscriptionReceived: '{channel}: new subscription — {what}',
    subscriptionReceivedAmount: '{channel}: new subscription — {what}, {amount} excl. tax',
    contactMessageReceived: '{channel}: new message from {name}',
    contactMessageReceivedSubject: '{channel}: new message from {name} — {subject}',
    depositReceived: '{channel}: new deposit "{title}"',
    depositReceivedBy: '{channel}: {name} deposited "{title}"',
    depositsReceived: '{channel}: {count} new files "{title}"',
    depositsReceivedBy: '{channel}: {name} deposited {count} files "{title}"',
    unknown: 'A notification this version of the application cannot describe yet.',
  },
}
